import { render, staticRenderFns } from "./InstructorList.vue?vue&type=template&id=0fbf729a&"
import script from "./InstructorList.vue?vue&type=script&lang=js&"
export * from "./InstructorList.vue?vue&type=script&lang=js&"
import style0 from "./InstructorList.vue?vue&type=style&index=0&id=0fbf729a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports